const stop = e => e.stopPropagation()

export const keepAppLayersOpen = {
  onMouseDown: stop,
  onPointerDown: stop,
  onTouchStart: stop,
  onTouchEnd: stop,
  onMouseUp: stop,
  onPointerUp: stop,
  onClick: stop,
}
